<template>
	<div>
		<div class="x-stat">
			<a-row>
				<a-col :span="3">
					<a-statistic title="数量" :value="totalRow" />
				</a-col>
			</a-row>
		</div>

		<a-card :bordered="false">
			<div class="x-filter">
				<a-form layout="inline">
					<a-row :gutter="24">
						<a-col :span="4">
							<a-form-item label="礼物名称">
								<a-input v-model="queryParams.giftName" placeholder="名称" />
							</a-form-item>
						</a-col>
						<template v-if="advanced">
							<a-col :md="8">
								<a-form-item label="创建时间">
									<a-range-picker @change="onCreateTime" v-model="createTime" style="width:100%" />
								</a-form-item>
							</a-col>
						</template>
						<a-col :span="!advanced && 4 || 24">
							<span class="x-filter-submit-box"
								:style="advanced && {float:'right', overflow:'hidden'} || {}">
								<a-button type="primary" @click="fetchTableData">查询</a-button>
								<a-button style="margin-left:8px" @click="rest()">重置</a-button>
								<a @click="toggleAdvanced" style="margin-left: 8px">
									{{ advanced ? '收起' : '展开' }}
									<a-icon :type="advanced ? 'up' : 'down'" />
								</a>
							</span>
						</a-col>
					</a-row>
				</a-form>
			</div>

			<div class="x-tool">
				<a-button type="primary" icon="plus" v-has="'/content/giftAdd'" @click="add">新增</a-button>
			</div>

			<a-table :rowKey="record => record.id" :columns="tableColumns" :loading="tableLoading"
				:dataSource="tableData" :pagination="false">
				
				<template slot="picUrl" slot-scope="record">
					<img class="cover-img" :src="record.picUrl" width="48px" height="48px" />
				</template>
				
				<template slot="codeUrl" slot-scope="record">
					<span>{{ record.codeUrl }}</span>
				</template>

				<template slot="action" slot-scope="record">
					<a v-has="'/content/giftUpdate'" @click="update(record)">修改</a>
					<a-divider type="vertical" />
					<a v-if="record.isEnable == 'Y'" v-has="'/content/giftSetEnable'" @click="setEnabled(record.id, 'N')">设为禁用</a>
					<a v-else v-has="'/content/giftSetEnable'" @click="setEnabled(record.id, 'Y')">设为启用</a>
				</template>
			</a-table>

			<Gift-form-modal ref="GiftForm" :visible="GiftFormVisible" :loading="GiftFormLoading" :model="GiftFormModel"
				@cancel="GiftFormCancel" @ok="GiftFormOk" />

			<div class="x-pagination">
				<a-pagination :pageSize="pageSize" v-model="pageIndex" :total="totalRow" @change="pageChange"
					:hideOnSinglePage="true" show-less-items />
			</div>
		</a-card>
	</div>
</template>

<script>
	import moment from "moment";
	import GiftFormModal from "@/pages/content/gift/GiftForm.vue";
	import {
		giftList,
		giftAdd,
		giftUpdate,
		giftSetEnabled
	} from "@/api/content/gift.js";

	const tableColumns = [{
			title: '#',
			dataIndex: 'id'
		},
		{
			title: '礼物名称',
			dataIndex: 'giftName'
		},
		{
			title: '图片',
			scopedSlots: {
				customRender: 'picUrl'
			}
		},
		{
			title: '价格(金币)',
			dataIndex: 'price'
		},
		{
			title: '排序',
			dataIndex: 'seq'
		},
		{
			title: '创建时间',
			dataIndex: 'created'
		},
		{
			title: '操作',
			scopedSlots: {
				customRender: 'action'
			}
		}
	];

	export default {
		components: {
			GiftFormModal
		},
		data() {
			return {
				advanced: false,
				queryParams: {},
				totalRow: 0,
				tableColumns,
				tableData: [],
				tableLoading: false,
				pageSize: 20,
				pageIndex: 1,
				GiftFormVisible: false,
				GiftFormLoading: false,
				GiftFormModel: null,
				createTime: [],
			}
		},
		created() {
			this.fetchTableData();
		},
		methods: {
			fetchTableData() {
				this.tableLoading = true;
				this.queryParams.pageSize = this.pageSize;
				this.queryParams.page = this.pageIndex;
				giftList(this.queryParams).then(res => {
					this.totalRow = res.data.totalRow;
					this.tableData = res.data.recordList;

					this.tableLoading = false;
				});
			},
			pageChange(current) {
				this.pageIndex = current;
				this.fetchTableData();
			},
			toggleAdvanced() {
				this.advanced = !this.advanced;
			},
			onCreateTime(values) {
				this.queryParams.startCreateTime = moment(values[0]).unix();
				this.queryParams.endCreateTime = moment(values[1]).unix();
			},
			onActiveTime(values) {
				this.queryParams.startActiveTime = moment(values[0]).unix();
				this.queryParams.endActiveTime = moment(values[1]).unix();
			},
			add() {
				this.GiftFormModel = null;
				this.GiftFormVisible = true;
				this.$nextTick(() => {
					if (this.$refs.GiftForm && this.$refs.GiftForm.initForm) {
						this.$refs.GiftForm.initForm();
					}
				});
			},
			update(record) {
				this.GiftFormModel = {
					...record
				};
				this.GiftFormVisible = true;
			},
			GiftFormOk() {
				const giftForm = this.$refs.GiftForm;
				if (!giftForm || !giftForm.$refs.adminForm) {
					return;
				}
				giftForm.$refs.adminForm.validate(valid => {
					if (!valid) {
						return;
					}
					const values = { ...giftForm.form };
					this.GiftFormLoading = true;
					if (values.id > 0) {
						giftUpdate(values).then(() => {
							this.GiftFormAfter('修改礼物成功');
						}).catch(() => {
							this.GiftFormLoading = false;
						});
					} else {
						giftAdd(values).then(() => {
							this.GiftFormAfter('新增礼物成功');
						}).catch(() => {
							this.GiftFormLoading = false;
						});
					}
				});
			},
			GiftFormCancel() {
				this.GiftFormModel = null;
				this.GiftFormVisible = false;
				if (this.$refs.GiftForm && this.$refs.GiftForm.initForm) {
					this.$refs.GiftForm.initForm();
				}
			},
			GiftFormAfter(message) {
				this.GiftFormVisible = false;
				this.GiftFormLoading = false;
				if (this.$refs.GiftForm && this.$refs.GiftForm.initForm) {
					this.$refs.GiftForm.initForm();
				}
				this.fetchTableData();
				this.$message.success(message);
			},
			rest() {
				this.createTime = [];
				this.queryParams = {}
			},
			setEnabled(id, disable) {
				giftSetEnabled(id, disable).then(() => {
					this.fetchTableData();
					if (disable == 'Y') {
						this.$message.success(`礼物已启用`);
					} else {
						this.$message.success(`礼物已禁用`);
					}
				})
			},
		}
	}
</script>

<style lang="less" scoped>
	
</style>